import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";
import { format } from 'date-fns';
import { boundInstallation } from "network/ApiAxios";
import secureLocalStorage from "react-secure-storage";

const AccountInformation = (props) => {
    const student = props.student
    const formDisabled = props.formDisabled
    const [license, setLicense] = useState()
    const [expirationDate, setExpirationDate] = useState()
    const app = JSON.parse(secureLocalStorage.getItem("app"));

    useEffect(() => {
        let expDate = computeExpirationDate(license?.subscription?.date, license?.subscription?.plan?.periodicity)
        setExpirationDate(expDate)
    }, [license])

    useEffect(() => {

        const runAsync = async () => {
            let params = {
                filter: { item: student._id },
                constraint: { app: app._id }
            }

            const response = await boundInstallation(params);
            const { data } = response;

            if (data.success) {

                setLicense(data.installation?.license)

            }

        }

        if (student?._id)
            runAsync();

    }, [student])

    let formatDate = (date) => {

        let formDate = date ? format(date, "yyyy-MM-dd") : ''
        return formDate
    }

    let computeExpirationDate = (date, periodicity) => {

        if (!(date && periodicity)) return ''

        let startDate = new Date(date);
        let endDate = new Date(startDate.setMonth(startDate.getMonth() + periodicity));
        
        return formatDate(endDate.toDateString())
    }

    return (
        <>
            <hr className="my-4" />

            <h6 className="heading-small text-muted mb-4">Account Information</h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-creation"
                            >
                                Creation Date
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-creation"
                                defaultValue={formatDate(student?.date)}
                                type="date"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-licenses"
                            >
                                License Key
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-licenses"
                                defaultValue={license?._id}
                                type="text"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-licenses"
                            >
                                Expiration Date
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-licenses"
                                defaultValue={expirationDate}
                                type="date"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default AccountInformation